import s from './index.module.css'
import { PlusIconFatty } from '@/utils/icons'

export const ButtonAdd = (props) => <button {...props} className={s.btnAdd}><PlusIconFatty /></button>

export const ButtonRemove = (props) => <button {...props} className={s.btnRemove}><PlusIconFatty /></button>